import { isTransferableAsset, getIssuerAddress, getAssetId, isWrappedV2Document, getDataV2, isWrappedV3Document } from '../../open-attestation';
import { TRANSFERABLE_RECORDS_TYPE } from '../../verify/fragments';
import { isSignedDocument, isDerived } from '../../w3c/vc';
import { CHAIN_ID } from '../supportedChains';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const getTransferableRecordsCredentialStatus = /* @__PURE__ */ __name((document) => {
  return [
    document?.credentialStatus
  ].flat()?.[0];
}, "getTransferableRecordsCredentialStatus");
const isTransferableRecord = /* @__PURE__ */ __name((document) => {
  let isTransferableAssetVal = false;
  if (isSignedDocument(document)) {
    const credentialStatus = getTransferableRecordsCredentialStatus(document);
    isTransferableAssetVal = credentialStatus?.type === TRANSFERABLE_RECORDS_TYPE;
  } else {
    isTransferableAssetVal = isTransferableAsset(document);
  }
  return isTransferableAssetVal;
}, "isTransferableRecord");
const getTokenRegistryAddress = /* @__PURE__ */ __name((document) => {
  let issuerAddress = "";
  if (isSignedDocument(document)) {
    const credentialStatus = getTransferableRecordsCredentialStatus(document);
    issuerAddress = credentialStatus?.tokenRegistry;
  } else {
    issuerAddress = getIssuerAddress(document);
  }
  return issuerAddress instanceof Array ? issuerAddress[0] : issuerAddress;
}, "getTokenRegistryAddress");
const getTokenId = /* @__PURE__ */ __name((document) => {
  let tokenId = "";
  if (isSignedDocument(document)) {
    const credentialStatus = getTransferableRecordsCredentialStatus(document);
    tokenId = credentialStatus?.tokenId;
  } else {
    tokenId = getAssetId(document);
  }
  return tokenId && `0x${tokenId}`;
}, "getTokenId");
function processOAChainId(document) {
  if (document.network?.chainId) {
    const chainId = parseInt(document.network.chainId, 10);
    if (Object.values(CHAIN_ID).map(Number).includes(chainId)) {
      return chainId;
    }
    throw new Error(`Chain ID ${chainId} is not supported`);
  }
  console.warn(
    "You are using an older version of Open-Attestation Document, to use the auto network feature, please use an updated version. Otherwise, please make sure that you select the correct network."
  );
  return void 0;
}
__name(processOAChainId, "processOAChainId");
const getChainId = /* @__PURE__ */ __name((document) => {
  if (isSignedDocument(document)) {
    const credentialStatus = getTransferableRecordsCredentialStatus(document);
    return credentialStatus?.tokenNetwork?.chainId;
  } else if (isWrappedV2Document(document)) {
    const documentData = getDataV2(document);
    const identityProofType = documentData?.issuers?.[0]?.identityProof?.type;
    if (identityProofType === "DNS-DID" || identityProofType === "DID") return void 0;
    return processOAChainId(documentData);
  } else if (isWrappedV3Document(document)) {
    const identityProofType = document?.openAttestationMetadata?.identityProof?.type;
    if (identityProofType === "DNS-DID" || identityProofType === "DID") return void 0;
    return processOAChainId(document);
  } else {
    return void 0;
  }
}, "getChainId");
const isObfuscated = /* @__PURE__ */ __name(async (document) => {
  if (isWrappedV3Document(document)) {
    return !!document.proof.privacy?.obfuscated?.length;
  }
  if (isWrappedV2Document(document)) {
    return !!document.privacy?.obfuscatedData?.length;
  }
  if (isSignedDocument(document)) {
    return await isDerived(document);
  }
  throw new Error(
    "Unsupported document type: Can only check if there are obfuscated data from wrapped OpenAttestation v2, v3 documents and signed verifiable credentials."
  );
}, "isObfuscated");
const getObfuscatedData = /* @__PURE__ */ __name((document) => {
  if (isWrappedV3Document(document)) {
    return document.proof.privacy?.obfuscated;
  }
  if (isWrappedV2Document(document)) {
    return document.privacy?.obfuscatedData || [];
  }
  throw new Error(
    "Unsupported document type: Can only retrieve obfuscated data from wrapped OpenAttestation v2 & v3 documents."
  );
}, "getObfuscatedData");

export { getChainId, getObfuscatedData, getTokenId, getTokenRegistryAddress, getTransferableRecordsCredentialStatus, isObfuscated, isTransferableRecord };
